import React, { useMemo } from 'react';
import { useLanguage } from '../../locale/useLanguage';
import { WeekDay } from '../../models';

import './WeekDayPicker.css';

type WeekDayPickerProps = {
  selectedDays?: WeekDay[];
  onDayClicked?: (weekDay: WeekDay) => void;
  disabledDays: WeekDay[];
};

export const WeekDayPicker: React.FC<WeekDayPickerProps> = ({
  onDayClicked,
  selectedDays = [],
  disabledDays
}) => {
  const [t] = useLanguage();

  const firstRow = useMemo(
    () => [
      { day: WeekDay.Mon, label: t('weekdays.monday') },
      { day: WeekDay.Tue, label: t('weekdays.tuesday') },
      { day: WeekDay.Wed, label: t('weekdays.wednesday') },
    ],
    [t]
  );

  const secondRow = useMemo(
    () => [
      { day: WeekDay.Thu, label: t('weekdays.thursday') },
      { day: WeekDay.Fri, label: t('weekdays.friday') },
      { day: WeekDay.Sat, label: t('weekdays.saturday') },
    ],
    [t]
  );

  return (
    <div>
      <div className="week-day-picker--row">
        {firstRow.map((e) => (
          <React.Fragment key={e.day}>
            <button
              onClick={() => onDayClicked?.(e.day)}
              className={`week-day-picker--day ${
                selectedDays?.find((d) => d === e.day) !== undefined
                  ? 'week-day-picker--day-selected'
                  : ''
              }`}
              style={{
                backgroundColor: disabledDays.includes(e.day) ? '#f2f2f2' : '',
                cursor: disabledDays.includes(e.day) ? 'not-allowed' : 'pointer'
              }}
              disabled={disabledDays.includes(e.day)}
            >
              {e.label.substring(0, 3)}
            </button>
          </React.Fragment>
        ))}
      </div>
      <div className="week-day-picker--row">
        {secondRow.map((e) => (
          <React.Fragment key={e.day}>
            <button
              onClick={() => onDayClicked?.(e.day)}
              className={`week-day-picker--day ${
                selectedDays?.find((d) => d === e.day)
                  ? 'week-day-picker--day-selected'
                  : ''
              }`}
              style={{
                backgroundColor: disabledDays.includes(e.day) ? '#f2f2f2' : '',
                cursor: disabledDays.includes(e.day) ? 'not-allowed' : 'pointer'
              }}
              disabled={disabledDays.includes(e.day)}
            >
              {e.label.substring(0, 3)}
            </button>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};
